import { useLiveQuery } from 'dexie-react-hooks';
import { userById as fromRoster, type User } from '@kilroy/shared';
import { db } from '../db/db';

/**
 * Resolve a user id to a person.
 *
 * The static roster is keyed by slug (`u-allan-miller`) because the client had
 * to render names before a database existed. The server returns real uuids.
 * Screens that reached straight for the roster rendered raw uuids at people.
 *
 * Server first — whatever the last pull stored — with the roster as the
 * fallback for anything still seeded client-side.
 */
export function useUsers() {
  const users = useLiveQuery(() => db.users.toArray(), [], [] as User[]);
  return {
    users,
    userById: (id: string): User => users.find((u) => u.id === id) ?? fromRoster(id),
  };
}
